import {ssrSafeWindow} from '@github-ui/ssr-utils'

/**
 * Clone URL the host uses to materialize the repo. Prefers the server-provided
 * `serverUrl`, else the browser origin + nwo (github.com during SSR).
 */
export function repoCloneUrl(nwo: string, serverUrl?: string): string {
  if (serverUrl) return serverUrl
  const origin = ssrSafeWindow?.location?.origin ?? 'https://github.com'
  return `${origin.replace(/\/$/, '')}/${nwo}`
}
